import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const adminApi = (username, password) =>
  axios.create({
    baseURL: API,
    auth: { username, password },
  });

export const publicApi = {
  listPlaylists: (categoryType) =>
    api.get('/playlists', { params: categoryType ? { category_type: categoryType } : {} }).then((r) => r.data),
  getPlaylist: (slug) => api.get(`/playlists/${slug}`).then((r) => r.data),
  getSong: (id) => api.get(`/songs/${id}`).then((r) => r.data),
  search: (q) => api.get('/search', { params: { q } }).then((r) => r.data),
};

export const adminAuth = {
  login: (username, password) => api.post('/admin/login', { username, password }).then((r) => r.data),
};
